import { Injectable } from "@angular/core";
import { ImpedimentoAfericao } from "@tivic-team/manager-ts/dist/mob/entities/concessao/impedimento-afericao.entity";
import { ImpedimentoAfericaoController } from "app/controllers/mob/impedimento-afericao.controller";
import { ApiService } from "../api-service.interface";
import { LoaderService } from "../loader.service";
import { ImpedimentoAfericaoSearch } from "./impedimento-afericao.search";

@Injectable()
export class ImpedimentoAfericaoService implements ApiService<ImpedimentoAfericao> {
    
  constructor(
    private _impedimentoAfericaoController: ImpedimentoAfericaoController,
    private _loaderService: LoaderService
  ) {}

  find(search?: ImpedimentoAfericaoSearch): Promise<ImpedimentoAfericao[]> {
    this._loaderService.show();
    return this._impedimentoAfericaoController.find((search && search.getFilters()) || null).finally(() => this._loaderService.hide());
  }

  get(id: number): Promise<ImpedimentoAfericao> {
    this._loaderService.show();
    return this._impedimentoAfericaoController.get(id).finally(() => this._loaderService.hide());
  }

  create(entity: ImpedimentoAfericao): Promise<ImpedimentoAfericao> {
    this._loaderService.show();
    return this._impedimentoAfericaoController.create(entity).finally(() => this._loaderService.hide());
  }

  update(entity: ImpedimentoAfericao): Promise<ImpedimentoAfericao> {
    this._loaderService.show();
    return this._impedimentoAfericaoController.update(entity).finally(() => this._loaderService.hide());
  }

  save(entity: ImpedimentoAfericao): Promise<ImpedimentoAfericao> {
    if (!entity.cdImpedimentoAfericao) return this.create(entity);

    return this.update(entity);
  }
}
